interface StoreLocatorProps {
  mapId: string;
  sectionId: string;
  title: {
    content: string;
    typo: string;
    as: string;
  }
}

const StoreLocator = ({ mapId, sectionId, title }: StoreLocatorProps) => {
  const normalizedData = {
    mapId,
    sectionId,
    title
  }

  return normalizedData
}

export default StoreLocator
